import { styled } from '../../../common/ui'

export const MainContent = styled.div`
  padding: 50px;
  background: #dadada;
  position: relative;
`
